import React from 'react';

const SectionTopBanners = ({ places = [], onSelectPlace }) => {
  if (!places.length) return null;

  return (
    <div className="container col-md-8 col-lg-6 p-0">
      <div className="d-flex overflow-auto">
        {places.map((place) => (
          <div key={place.id} className="place_square-box ml-2 mt-3" onClick={() => onSelectPlace && onSelectPlace(place.id)} role="button">
            <img src={ place.image_data_medium || place.image_data || '/assets2019/img/icon_camera.svg'}
            alt={place.name} className="place_square-img"/>
            <span className="place_square-overlay">{place.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionTopBanners;
